<template>
  <el-select
    class="select"
    v-model="data"
    :clearable="clearable"
    :size="size"
    :filterable="filterable"
    :filter-method="filterMethod"
    :disabled="isDisabled"
    :popper-append-to-body="popperAppendToBody"
    :placeholder="placeholder"
  >
    <el-option
      v-for="(item, index) in list"
      :label="label ? item[label] : item"
      :value="value ? item[value] : item"
      :key="index"
      :disabled="hasDisabled(item)"
    >
      <slot :data="item"></slot>
    </el-option>
  </el-select>
</template>

<script>
import i18n from '@/i18n/index.js';
export default {
  name: 'MySelect',
  model: {
    prop: 'select', // 要存在于props
    event: 'change' // 当组件的值发生改变时要emit的事件名
  },
  props: {
    select: {
      // 默认值
      type: [String, Number, Boolean]
    },
    size: {
      // select大小
      type: String,
      default: 'small'
    },
    filterable: {
      // 是否支持搜索
      type: Boolean,
      default: false
    },
    popperAppendToBody: {
      // 是否加入在body
      type: Boolean,
      default: true
    },
    placeholder: {
      // 提示语
      type: String,
      default: () => i18n.t('HT.pleaseSelect')
    },
    label: {
      type: String,
      default: 'label'
    },
    value: {
      type: String,
      default: 'value'
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    clearable: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      // 是否禁用
      type: Boolean,
      default: false
    },
    filterMethod: {
      //搜索方法
      type: Function
    },
    disabled: {
      // 禁用的数组
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      data: this.select
    };
  },

  methods: {
    /**
     * 判断是否禁用
     * @param {Object} item 单个对象
     */
    hasDisabled(item) {
      if (item.disabled) return item.disabled;
      let result = false;
      let value = item[this.value];
      if (this.disabled.length) {
        for (let i = 0; i < this.disabled.length; i++) {
          if (value === this.disabled[i]) {
            result = true;
            break;
          }
        }
      }
      return result;
    }
  },

  watch: {
    // 这里检测data中的值，一旦发生变化就提交事件到父组件
    data: {
      handler(newVal) {
        this.$emit('change', newVal);
      },
      deep: true
    },
    select: {
      handler(newVal) {
        this.data = newVal;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.select {
  width: 100%;
}
</style>
